import WalletStorageService from './WalletStorageService';

export default WalletStorageService;
